import type { AdminOperationsSummary } from "@/types/admin-operations";

/**
 * Canonical operations-summary fixture, derived from the 8-user scenario set:
 *
 *  - 1 trial card_failed (Dave)            → trialConversionFailures = 1
 *  - 1 trial charged_off (Erin)            → trialChargeOffRisk = 1
 *  - 1 trial_ending_soon (Cara)            → trialEndingSoon = 1
 *  - 1 past_due (Finn)                     → paymentFailures = 1
 *  - 2 reclaim records (Erin, Gina)        → reclaimPending = 2
 *  - 1 reclaim with no carrier scan (Erin) → carrierScanPending = 1
 *  - 0 awaiting warehouse receipt yet      → warehouseReceiptPending = 0
 *  - 1 awaiting refurb QC (Gina scrap)     → refurbQcPending = 1
 *  - 1 declined $75 damage fee (rma_q15)   → restockingFeeFailed = 1
 *  - 2 fraud queue (Erin, Gina)            → fraudReviewQueue = 2
 *  - 2 open disputes (dp_001 + 1 added)    → disputesOpen = 2
 *  - 1 deletion requested (Hugo)           → accountDeletionRequests = 1
 *  - 3 dangerous audit events seeded       → recentDangerousActions = 3
 */
export const MOCK_OPERATIONS_SUMMARY: AdminOperationsSummary = {
  trialConversionFailures: 1,
  trialChargeOffRisk: 1,
  trialEndingSoon: 1,
  paymentFailures: 1,
  reclaimPending: 2,
  carrierScanPending: 1,
  warehouseReceiptPending: 0,
  refurbQcPending: 1,
  restockingFeeFailed: 1,
  fraudReviewQueue: 2,
  disputesOpen: 2,
  accountDeletionRequests: 1,
  recentDangerousActions: 3,
};
